// extracted by mini-css-extract-plugin
export default {"container":"styles_container__B5tb9","icon":"styles_icon__vTK4a","tooltip":"styles_tooltip__YAGGO"};